import React from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";

export const ProjectCard = ({ title = null, value = null, color, icon = null }) => {
  return (
    <Card
      sx={{
        flex: 1,
        minWidth: 220,
        borderRadius: "12px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      }}
    >
      <CardContent
        sx={{
          "&:last-child": { pb: 2 }, // prevent extra bottom padding from MUI
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
        >
          <Typography variant="caption" sx={{ color, letterSpacing: "1px", fontWeight: "bold" }}>
            {title}
          </Typography>

          {icon && (
            <Box
              sx={{
                width: 32,
                height: 32,
                borderRadius: "50%",
                border: `2px solid ${color}`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color,
              }}
            >
              {icon}
            </Box>
          )}
        </Box>

        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            lineHeight: 1.2, // reduces visual bottom gap
            mt: 0,
          }}
        >
          {value}
        </Typography>
      </CardContent>
    </Card>
  );
};
